<template>
    <div class="container-header" @mouseover="onChild=true" @mouseleave="onChild=false">
        <div class="border-header"></div>
        <div class="wrap-header" :class="{'active':onChild}">
            <div class="img-logo header" @click="$router.push('/')"></div>
            <div class="wrap-tab-header">
<!--                <button class="tab-header" :class="{active:$route.meta.main === '코인존'}" @click="$router.push('/coin')">-->
<!--                    포인트&코인존-->
<!--                </button>-->

              <button class="tab-header" :class="{active:$route.meta.main === '선물함'}" @click="$router.push('/')">
                선물함
              </button>

                <button v-if="showLiveSubscriptionTab" class="tab-header" :class="{active:$route.meta.main === '라이브 구독'}"
                        @click="$router.push('/subscript')">라이브 구독
                </button>
                <button class="tab-header" :class="{active:$route.meta.main === '이웃 파트너'}"
                        @click="$router.push('/partner')">이웃파트너
                </button>
                <button class="tab-header" :class="{active:$route.meta.main === '마이페이지'}"
                        @click="$router.push('/payment/product')">마이페이지
                </button>
                <button class="tab-header" :class="{active:$route.meta.main === '고객센터'}"
                        @click="$router.push('/mypage/notice')">고객센터
                </button>
            </div>
            <div class="wrap-btn-header">
                <div class="btn-header name" disabled="true" v-if="UserInfo.mbName != ''">
                    {{ UserInfo.mbName }} 님
                </div>
                <button class="btn-header" @click="logout()">로그아웃</button>
            </div>
            <button class="btn-alarm" @click="showAlarm()"></button>

        </div>

        <div class="box-header" :class="{'active':onChild}">
            <div class="wrap-child-header">
                <div class="img-logo header child" @click="$router.push('/')"></div>
                <div class="wrap-btn-child-header">
<!--                    <div>-->
<!--                        <div v-for="(data,index) in setMenu('코인존')" :key="`${data}_coin`"-->
<!--                             @click="$router.push(`${data.path}`)"-->
<!--                             class="btn-header-child"-->
<!--                             :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"-->
<!--                        >-->
<!--                            {{ data.meta.title }}-->
<!--                        </div>-->
<!--                    </div>-->

                  <div>
                    <div v-for="(data,index) in setMenu('선물함')" :key="`${data}_gift`"
                         @click="$router.push(data.name === 'GiftCoin' ? '/coin' : `${data.path}`)"
                         class="btn-header-child"
                         :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"
                    >
                      {{ data.meta.title }}
                    </div>
                  </div>
                    <div v-if="showLiveSubscriptionTab">
                        <div v-for="(data,index) in setMenu('라이브 구독')" :key="`${data}_sub`"
                             @click="$router.push(`${data.path}`)" class="btn-header-child"
                             :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"
                        >
                            {{ data.meta.title }}
                        </div>
                    </div>
                    <div>
                        <div v-for="(data,index) in setMenu('이웃 파트너')" :key="`${data}_parnter`"
                             @click=" checkPartner(data.path)" class="btn-header-child"
                             :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"
                        >
                            {{ data.meta.title }}
                        </div>
                    </div>
                    <div>
                        <div v-for="(data,index) in setMenu('마이페이지')" :key="`${data}_my`"
                             @click="$router.push(`${data.path}`)" class="btn-header-child"
                             :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"
                        >
                            {{ data.meta.title }}
                        </div>
                    </div>
                    <div>
                        <div v-for="(data,index) in setMenu('고객센터')" :key="`${data}_customer`"
                             @click="$router.push(`${data.path}`)" class="btn-header-child"
                             :class="{'active' : data.meta.mainClass === $route.meta.mainClass}"
                        >
                            {{ data.meta.title }}
                        </div>
                    </div>
                </div>
                <div class="wrap-btn-header child">
                    <div class="btn-header name" disabled="true">
                        {{ UserInfo.mbName }} 님
                    </div>
                    <button class="btn-header" @click="logout()">로그아웃</button>
                </div>
                <button class="btn-alarm child" @click="showAlarm()">
                    <!--                    $router.push('/alarm')-->
                </button>

            </div>

        </div>

    </div>
    <alarm-modal></alarm-modal>

    <subscript-modal></subscript-modal>
    <update-temp-pwd-modal></update-temp-pwd-modal>
</template>


<script>
import {mapState} from "vuex";
import {confirmLogout} from "@/mixins/Auth";
import AlarmModal from "@/components/modal/AlarmModal.vue";
import AlertMixins from "@/mixins/alertMixins";
import SubscriptModal from "@/components/modal/SubscriptModal.vue";
import popupMixin from "@/mixins/popupMixin";
import UpdateTempPwdModal from "@/components/modal/UpdateTempPwdModal.vue";

export default {
    name: "PageHeader",
    mixins: [AlertMixins, popupMixin],
    components: {
        AlarmModal, SubscriptModal, UpdateTempPwdModal
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            onChild: false,
            showLiveSubscriptionTab: true,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.fetchChannelDisplay();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
            liveChannelDisplay: state => state.common.liveChannelDisplay.WEB.list,
        })
    },
    methods: {
        checkPartner(data) {
            if (data === '/mypage/video/publishing') {
                if (!this.isJoinPartner('MEDIA')) {
                    this.createConfirm(
                        {
                            title:'이웃파트너 회원가입',
                            content:'영상 이웃파트너만 접근 가능한 페이지 입니다.<br>이웃파트너로 가입하시겠습니까?',
                            confirm: () => {
                                this.showNoticePartnerPush(data);
                            },
                        }
                    )
                }
                else{
                    this.$router.push(`${data}`)
                }

            } else if(data === '/advertise'){
                if (!this.isJoinPartner('ADVERTISEMENT')) {
                    this.createConfirm(
                        {
                            title:'이웃파트너 회원가입',
                            content:'광고 이웃파트너만 접근 가능한 페이지 입니다.<br>이웃파트너로 가입하시겠습니까?',
                            confirm: () => {
                                this.showNoticePartnerPush(data);
                            },
                        }
                    )
                } else{
                    this.$router.push(`/advertise`)
                }

            } else if(data === '/shopping'){
                if (!this.isJoinPartner('SHOPPING')) {
                    this.createConfirm(
                        {
                            title:'이웃파트너 회원가입',
                            content:'쇼핑 이웃파트너만 접근 가능한 페이지 입니다.<br>이웃파트너로 가입하시겠습니까?',
                            confirm: () => {
                                this.showNoticePartnerPush(data);
                            },
                        }
                    )
                } else{
                    this.$router.push(`/shopping`)
                }

            }
            else {
                this.$router.push(`${data}`)
            }
        },
        showNoticePartnerPush(data) {
            this.createAlert({
                title: '이웃 파트너 푸시 알림 동의 안내',
                content: '이웃 파트너의 영상에 대한 업로드, 승인, 결제, 콘텐츠 정보 등의 안내를 푸시로 안내드립니다.<br>*앱 푸시 알림 거부 시  사용에 불편함이 있을 수 있습니다.<br>마이페이지 - 알림설정 페이지에서 설정 변경이 가능합니다.',
                hide: () => {
                    if (data === '/mypage/video/publishing') {
                        this.$router.push('/partner/join/media');

                    } else if(data === '/advertise'){
                        this.$router.push('/partner/join/advertisement');

                    } else if(data === '/shopping'){
                        this.$router.push('/partner/join/shopping');
                    }
                }
            })
        },
        isJoinPartner(value) {
            if (this.UserInfo.mpTypeEnums.includes(value)) {
                return true;
            } else {
                return false;
            }
        },
        fetchChannelDisplay() {
            if (!Array.isArray(this.liveChannelDisplay) || this.liveChannelDisplay.length === 0) {
                this.showLiveSubscriptionTab = true;
                return;
            }

            this.showLiveSubscriptionTab = !this.liveChannelDisplay.every(channel => Number(channel.lcdiDisplay) === 0);
        },


        logout() {
            confirmLogout();
        },

        setMenu(data) {
            return this.$router.options.routes.filter(route => {
                if (route.meta.sideHidden == false) {
                    return route.meta && route.meta.main === data;
                }
            });

        },
        showAlarm() {
            this.$vfm.show("alarm-modal");
        },
        // getToken() {
        //     let RESULTCODE = {
        //         INVALIDE_PARAMETER: "INVALID_PARAMETER",
        //         SUCCEEDED: "SUCCEEDED",
        //         ERROR: "ERROR"
        //     }
        //     return axios.get(`${apiURL + 'auth/refresh?type=user'}`)
        //         .then(res => {
        //             if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
        //                 alert("문제가 발생했습니다. 다시 시도해 주세요.");
        //                 router.push('/')
        //                 return res;
        //             } else {
        //                 let result = res.data.Data.Result;
        //                 if (result.Info.type === 1) {
        //                     let token = result.List
        //                     this.$localStorage.set('token', token);
        //                     setAuthInHeader(token);
        //                 } else if (result.Info.type == -270) {
        //                     logout();
        //                 }
        //                 return res;
        //             }
        //         }).catch(({response}) => {
        //             router.push('/')
        //             const {status} = response;
        //             if (status === 400 || status === 401 || status === 500) {
        //
        //             } else if (status === Errored) {
        //                 alert("잘못된 정보입니다.")
        //             }
        //             throw Error(response) //
        //         })
        // }
    },
    watch: {
        liveChannelDisplay() {
            this.fetchChannelDisplay();
        },
    },
}
</script>

<style scoped>

</style>
